import React, { useState } from "react";
import DatePicker from "./ui/DatePicker";
import Button from "./ui/Button";

const PERIODS = [
  { value: "danas", label: "Danas" },
  { value: "juce", label: "Juče" },
  { value: "nedelja", label: "Ova nedelja" },
  { value: "mesec", label: "Ovaj mesec" },
  { value: "prosli_mesec", label: "Prošli mesec" },
];

// "2026-10-05" -> "05.10.2026"
function fmt(iso) {
  const [y, m, d] = String(iso || "").split("-");
  return y && m && d ? `${d}.${m}.${y}` : "";
}

const segClass = (active) =>
  `h-8 shrink-0 whitespace-nowrap rounded px-3 text-sm font-medium transition-colors ${
    active
      ? "bg-surface text-slate-900 shadow-card dark:bg-slate-700 dark:text-white"
      : "text-slate-600 hover:text-slate-900 dark:text-slate-400 dark:hover:text-slate-100"
  }`;

export default function QuickPeriodBar({ period, onPeriodChange, startDate, endDate, onCustomApply }) {
  const [showCustom, setShowCustom] = useState(false);
  const [draftStartDate, setDraftStartDate] = useState(startDate);
  const [draftEndDate, setDraftEndDate] = useState(endDate);

  const handleCustomOpen = () => {
    setDraftStartDate(startDate);
    setDraftEndDate(endDate);
    setShowCustom((prev) => !prev);
  };

  const handleApply = () => {
    onCustomApply(draftStartDate, draftEndDate);
    setShowCustom(false);
  };

  const range = startDate === endDate ? fmt(startDate) : `${fmt(startDate)} - ${fmt(endDate)}`;

  return (
    <div className="flex min-h-[3.75rem] min-w-0 flex-wrap items-end gap-x-3 gap-y-2">
      {/* Segmented control: scrolls horizontally on a narrow screen instead of wrapping */}
      <div
        role="group"
        aria-label="Period"
        className="no-scrollbar inline-flex max-w-full overflow-x-auto rounded-md border border-slate-300 bg-slate-100 p-0.5 dark:border-slate-700 dark:bg-slate-900"
      >
        {PERIODS.map((p) => (
          <button
            key={p.value}
            type="button"
            aria-pressed={period === p.value}
            onClick={() => {
              onPeriodChange(p.value);
              setShowCustom(false);
            }}
            className={segClass(period === p.value)}
          >
            {p.label}
          </button>
        ))}
        <button
          type="button"
          aria-pressed={period === "prilagodi" || showCustom}
          aria-expanded={showCustom}
          onClick={handleCustomOpen}
          className={segClass(period === "prilagodi" || showCustom)}
        >
          Prilagodi period
        </button>
      </div>

      {showCustom ? (
        <>
          <DatePicker label="Datum od" value={draftStartDate} onChange={setDraftStartDate} />
          <DatePicker label="Datum do" value={draftEndDate} onChange={setDraftEndDate} />
          <Button onClick={handleApply}>Primeni</Button>
        </>
      ) : (
        <span className="pb-2 text-xs tabular-nums text-slate-500 dark:text-slate-400">{range}</span>
      )}
    </div>
  );
}
